// Original MY PORTAL sound identities. They are generated with Web Audio so
// the product owns the melody and no third-party sound is copied.
export const PAY_SOUNDS = [
  { id: "myportal_signature", label: "MY PORTAL Signature", description: "Warm arrival with a crisp final mark" },
  { id: "bright_route", label: "Bright Route", description: "Quick, optimistic four-note route" },
  { id: "soft_arrival", label: "Soft Arrival", description: "Gentle and discreet confirmation" },
];

const scores = {
  myportal_signature: [
    { f: 523.25, t: 0.00, d: 0.20, type: "triangle", g: 0.68 },
    { f: 659.25, t: 0.12, d: 0.24, type: "triangle", g: 0.72 },
    { f: 783.99, t: 0.25, d: 0.26, type: "sine", g: 0.78 },
    { f: 1046.50, t: 0.43, d: 0.48, type: "sine", g: 0.52 },
    { f: 392.00, t: 0.43, d: 0.52, type: "triangle", g: 0.22 },
  ],
  bright_route: [
    { f: 659.25, t: 0.00, d: 0.18, type: "triangle", g: 0.65 },
    { f: 830.61, t: 0.11, d: 0.18, type: "triangle", g: 0.68 },
    { f: 987.77, t: 0.22, d: 0.20, type: "triangle", g: 0.72 },
    { f: 1318.51, t: 0.36, d: 0.38, type: "sine", g: 0.52 },
  ],
  soft_arrival: [
    { f: 440.00, t: 0.00, d: 0.32, type: "sine", g: 0.42 },
    { f: 554.37, t: 0.18, d: 0.36, type: "sine", g: 0.48 },
    { f: 659.25, t: 0.38, d: 0.55, type: "sine", g: 0.44 },
  ],
};

export const playPaySound = (soundId = "myportal_signature", volume = 0.8) => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return false;
  try {
    const ctx = new AudioCtx();
    const master = ctx.createGain();
    master.gain.setValueAtTime(0.0001, ctx.currentTime);
    const safeVolume = Math.max(0.1, Math.min(1, Number(volume) || 0.8));
    master.gain.exponentialRampToValueAtTime(0.16 * safeVolume, ctx.currentTime + 0.02);
    master.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 1.35);
    master.connect(ctx.destination);
    (scores[soundId] || scores.myportal_signature).forEach((note) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = note.type;
      osc.frequency.value = note.f;
      const start = ctx.currentTime + note.t;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(note.g, start + 0.025);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + note.d);
      osc.connect(gain); gain.connect(master); osc.start(start); osc.stop(start + note.d + 0.04);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1600);
    return true;
  } catch { return false; }
};
